<div *ngIf="isLoading" class="overlay">
    <div class="lds-facebook">
      <div></div>
      <div></div>
      <div></div>
    </div>
</div>
